import axios from "axios";
import { Base_URL } from "../url";

export const fetchMerchants = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetAllMerchants/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching merchants!";
  }
};

export const downloadMerchantsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/MerchantMaster/DownloadMerchantsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading merchants data!";
  }
};